import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
import { Services } from '../components/Services';
import { Benefits } from '../components/Benefits';
import { About } from '../components/About';
import { Gallery } from '../components/Gallery';
import { Testimonials } from '../components/Testimonials';
import { GoogleReviews } from '../components/GoogleReviews';
import { Contact } from '../components/Contact';
import { QuoteForm } from '../components/QuoteForm';
import { PriceEstimator } from '../components/PriceEstimator';

/**
 * Pages dédiées du site.
 *
 * Chaque entrée du menu a sa propre adresse : le visiteur peut la partager,
 * la mettre en favori, et Google l'indexe séparément — ce qu'une simple ancre
 * sur la page d'accueil ne permet pas.
 */
const Page = ({ titre, description, fil, children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useSeo({ title: `${titre} | NETTO+`, description });

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <nav aria-label="Fil d'Ariane" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-28">
          <ol className="flex flex-wrap items-center gap-2 text-sm text-gray-500">
            <li>
              <Link to="/" className="hover:text-blue-600">Accueil</Link>
            </li>
            <li aria-hidden="true">/</li>
            <li className="text-gray-900 font-medium">{fil || titre}</li>
          </ol>
        </nav>
        {children}
      </main>
      <Footer />
      <FloatingContact />
    </div>
  );
};

export const ServicesPage = () => (
  <Page
    titre="Nos services de nettoyage"
    description="Nettoyage de bureaux, maisons, vitres, fin de chantier et fin de bail à Liège et dans toute la Belgique."
    fil="Services"
  >
    <Services />
    <Benefits />
    <PriceEstimator />
    <QuoteForm />
  </Page>
);

export const AProposPage = () => (
  <Page
    titre="À propos de NETTO+"
    description="NETTO+, entreprise de nettoyage à Liège. 30 ans de métier, société établie depuis 2016."
    fil="À propos"
  >
    <About />
    <Benefits />
    <Gallery />
  </Page>
);

export const AvisPage = () => (
  <Page
    titre="Avis de nos clients"
    description="Ce que disent les clients de NETTO+ : avis Google et témoignages."
    fil="Avis clients"
  >
    <GoogleReviews />
    <Testimonials />
    <QuoteForm />
  </Page>
);

export const ContactPage = () => (
  <Page
    titre="Nous contacter"
    description="Contactez NETTO+ à Liège : téléphone, email et formulaire. Réponse sous 24h."
    fil="Contact"
  >
    <Contact />
  </Page>
);

export const DevisPage = () => (
  <Page
    titre="Demander un devis gratuit"
    description="Demandez un devis gratuit à NETTO+. Réponse sous 24 heures, sans engagement."
    fil="Devis gratuit"
  >
    <PriceEstimator />
    <QuoteForm />
  </Page>
);
